import {createNumberInput, createMathOperator} from "#mattress/assets-definitions/common"
import {createPath, dimensionPathName, numberInputMetaData, panelPathName, bottomPanelPathName, topPanelPathName} from "#mattress/mattress-meta-data"

export function getComponentGraphNodesForNonStackableStandardModelDimensionsLogic() {
    const width = createNumberInput("Width", "width", 140, numberInputMetaData([createPath(dimensionPathName, 0)], 50, 300, 0))
    const length = createNumberInput("Length", "length", 200, numberInputMetaData([createPath(dimensionPathName, 0)], 50, 300, 1))
    const height = createNumberInput("Height", "height", 20, numberInputMetaData([createPath(dimensionPathName, 0)], 1, 100, 2))
    const cornerRadius = createNumberInput("Corner Radius", "corner-radius", 5, numberInputMetaData([createPath(dimensionPathName, 0)], 1, 20, 3))
    const topRadius = createNumberInput("Top Radius", "top-radius", 2, numberInputMetaData([createPath(dimensionPathName, 0)], 1, 20, 4))
    const bottomRadius = createNumberInput("Bottom Radius", "bottom-radius", 2, numberInputMetaData([createPath(dimensionPathName, 0)], 1, 20, 5))

    const halfHeight = createMathOperator("Half Height", "mul", height, 0.5)
    const safeIntermediateBottomRadius = createMathOperator("Safe Bottom Radius (Intermediate)", "min", bottomRadius, cornerRadius)
    const safeIntermediateTopRadius = createMathOperator("Safe Top Radius (Intermediate)", "min", topRadius, cornerRadius)

    const safeBottomRadius = createMathOperator("Safe Bottom Radius", "min", safeIntermediateBottomRadius, halfHeight)
    const safeTopRadius = createMathOperator("Safe Top Radius", "min", safeIntermediateTopRadius, halfHeight)

    return {
        width,
        length,
        height,
        cornerRadius,
        topRadius,
        bottomRadius,
        safeIntermediateBottomRadius,
        safeIntermediateTopRadius,
        safeBottomRadius,
        safeTopRadius,
    }
}

export function getComponentGraphNodesForStackableStandardModelDimensionsLogic() {
    const width = createNumberInput("Width", "width", 140, numberInputMetaData([createPath(dimensionPathName, 0)], 50, 300, 0))
    const length = createNumberInput("Length", "length", 200, numberInputMetaData([createPath(dimensionPathName, 0)], 50, 300, 1))
    const cornerRadius = createNumberInput("Corner Radius", "corner-radius", 5, numberInputMetaData([createPath(dimensionPathName, 0)], 1, 20, 6))
    const topRadius = createNumberInput("Top Radius", "top-radius", 2, numberInputMetaData([createPath(dimensionPathName, 0)], 1, 20, 4))
    const bottomRadius = createNumberInput("Bottom Radius", "bottom-radius", 2, numberInputMetaData([createPath(dimensionPathName, 0)], 1, 20, 5))
    const bottomHeight = createNumberInput(
        "Bottom Height",
        "bottom-height",
        4,
        numberInputMetaData([createPath(dimensionPathName, 0), createPath(panelPathName, 0, createPath(bottomPanelPathName, 2))], 1, 100, 3),
    )
    const topHeight = createNumberInput(
        "Top Height",
        "top-height",
        4,
        numberInputMetaData([createPath(dimensionPathName, 0), createPath(panelPathName, 0, createPath(topPanelPathName, 0))], 1, 100, 2),
    )
    const safeBottomRadius = createMathOperator("Safe Bottom Radius", "min", cornerRadius, bottomRadius)
    const safeTopRadius = createMathOperator("Safe Top Radius", "min", cornerRadius, topRadius)

    return {
        width,
        length,
        cornerRadius,
        topRadius,
        bottomRadius,
        bottomHeight,
        topHeight,
        safeBottomRadius,
        safeTopRadius,
    }
}
